// extracted by mini-css-extract-plugin
export default {"text":"GamesCompleted_text__+oKpF","container":"GamesCompleted_container__ZTr7w","title":"GamesCompleted_title__8Zm21","message":"GamesCompleted_message__pGm+R"};